import React, { useState, createContext, useContext } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import './Authentication.css';
import NewDropdown from '../Ui/NewDropdown';

export const DropdownContext = createContext();

export const useDropdownContext = () => useContext(DropdownContext);

const Profile = ({ children }) => {
	const { user, isAuthenticated, isLoading } = useAuth0();
	const [dropdownIsOpen, setDropdownIsOpen] = useState(false);
	
	const closeDropdown = () => {
		setDropdownIsOpen(false);
	};
	
	if (isLoading) {
		return <div className="profileNav">Loading ...</div>;
	}

	if (!isAuthenticated) {
		return <div></div>;
	}
	const btn = <a className="userAuthBtn flex" onClick={(e) => e.stopPropagation()}>
		<div className="userAuthName">{user?.name || user?.email}</div>
	</a>;
	
	const cloneChildrenWithProps = (children) => {
		return React.Children.map(children, child => {
			if (React.isValidElement(child)) {
				const newChildren = child.props.children ? cloneChildrenWithProps(child.props.children) : child.props.children;
				return React.cloneElement(child, { closeDropdown, ...child.props }, newChildren);
			}
			return child;
		});
	};
	
	const childrenWithProps = cloneChildrenWithProps(children);
	
	return (
		isAuthenticated && (
			<div className="userAuth" onClick={(e) => e.stopPropagation()}>
				<DropdownContext.Provider value={{ closeDropdown }}>
					<NewDropdown
						isOpen={dropdownIsOpen}
						setIsOpen={(e) => {
							e?.stopPropagation && e.stopPropagation();
							setDropdownIsOpen(!dropdownIsOpen);
						}}
						onHide={(e) => {
							e?.stopPropagation && e.stopPropagation();
							setDropdownIsOpen(false);
						}}
						button={btn}
					>
						<ul className="listbox" onClick={(e) => e.stopPropagation()}>
							<li className="listbox_item" onClick={(e) => e.stopPropagation()}>{childrenWithProps}</li>
						</ul>
					</NewDropdown>
				</DropdownContext.Provider>
			</div>
		)
	);
};

export default Profile;
